import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune_sns_and_communitysite.png'

const paperInfo = {
    paperName: '熱量の高いファンを育てる-SNSとコミュニティサイトの効果的な使い分け-',
    thumbnail,
    feature1: 'ファンのビジネス貢献',
    feature2: 'ユーザーの熱量を高め、ファン化するまでのステップ',
    feature3: 'コミュニティサイトとSNSの使い分け',
    description:
        '自社製品やサービスを支持してくれる「ファン」を商品開発やマーケティングに活かす企業が増えています。現代におけるファンづくりの重要性、熱量の高いファンを育てる効果的なSNSとコミュニティサイトの使い分けについて解説しています。',
    formSrc: 'https://go.commmune.jp/l/915341/2022-09-19/kc6vp',
    type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
    return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
